import {BenchlingAction} from 'redux-stores/Action';

import {RealtimeEncryptionActionType, RealtimeEncryptionKey} from './RealtimeEncryptionReduxActions';

export interface ChannelEncryptionKeys {
  pastKey?: RealtimeEncryptionKey;
  currentKey?: RealtimeEncryptionKey;
  nextKey?: RealtimeEncryptionKey;
}

export interface RealtimeEncryptionState {
  keysByChannel: Record<string, ChannelEncryptionKeys>;
}

const INITIAL_STATE: RealtimeEncryptionState = {
  keysByChannel: {},
};

export default function reduceRealtimeEncryptionState(
  state: RealtimeEncryptionState = INITIAL_STATE,
  action: BenchlingAction
): RealtimeEncryptionState {
  if (action.type === RealtimeEncryptionActionType.SET_ENCRYPTION_KEY) {
    const {channel, pastKey, currentKey, nextKey} = action;
    if (!channel) {
      return state;
    }

    return {
      ...state,
      keysByChannel: {
        ...state.keysByChannel,
        [channel]: {
          pastKey,
          currentKey,
          nextKey,
        },
      },
    };
  }

  if (action.type === RealtimeEncryptionActionType.CLEAR_ENCRYPTION_KEY) {
    const {channel} = action;
    if (!channel) {
      // Clear all channels
      return {
        ...state,
        keysByChannel: {},
      };
    }

    // Clear specific channel
    const newKeysByChannel = {...state.keysByChannel};
    delete newKeysByChannel[channel];
    return {
      ...state,
      keysByChannel: newKeysByChannel,
    };
  }

  return state;
}
